import { render, staticRenderFns } from "./ClienteSemMovimentacaoAnual.vue?vue&type=template&id=28eaba6e&scoped=true&"
import script from "./ClienteSemMovimentacaoAnual.vue?vue&type=script&lang=js&"
export * from "./ClienteSemMovimentacaoAnual.vue?vue&type=script&lang=js&"
import style0 from "./ClienteSemMovimentacaoAnual.vue?vue&type=style&index=0&id=28eaba6e&scoped=true&lang=css&"
import style1 from "./ClienteSemMovimentacaoAnual.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eaba6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
